<template>
  <div class="custom-dropdown" @click="toggleDropdown" ref="dropdown">
    <!-- Seçilen değer -->
    <div class="dropdown-selected">
      {{ selectedLabel }}
       
    </div>

    <!-- Menü -->
    <ul v-if="isOpen" class="dropdown-menu">
      <li
        v-for="option in options"
        :key="option.value"
        @click.stop="selectOption(option)"
        class="dropdown-item"
      >
        {{ option.label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CustomDropdown",
  props: {
    modelValue: { type: String, default: "" },
    options: { type: Array, required: true } // [{ value: "USD", label: "USD - US Dollar" }]
  },
  data() {
    return { isOpen: false };
  },
  computed: {
    selectedLabel() {
      const found = this.options.find(o => o.value === this.modelValue);
      return found ? found.label : this.options[0]?.label || "";
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.$emit("update:modelValue", option.value);
      this.isOpen = false;
    },
    handleClickOutside(e) {
      if (!this.$refs.dropdown.contains(e.target)) {
        this.isOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.custom-dropdown {
  position: relative;
  width: 100%;
  cursor: pointer;
  user-select: none;
      font-family: "Rubik", sans-serif;
    font-size: 14px;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
}

.dropdown-selected {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background: var(--background2);
  border: 2px solid var(--bar-outer);
  border-radius: 12px;
  color: #f1f5f9;
  font-size: 14px;
  font-weight: 500;
}

.arrow {
  margin-left: 10px;
  font-size: 12px;
  color: #94a3b8;
  transition: transform 0.2s;
}

.custom-dropdown.open .arrow {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  width: 100%;
  background: #0f172a;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.3);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  padding: 5px 0;
}

.dropdown-item {
  padding: 10px 14px;
  color: #f1f5f9;
  font-size: 14px;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background: #191939;
}
</style>
